import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import ClockImage from './ClockImage';

import {
    formatText,
} from './helpers/format-text';

import styles from './Badge.module.scss';

const Badge: FC<IProps> = (props) => {
    return (
        <div
            className={
                classNames(styles.badge, props.className, {
                    [styles.success]: props.type === 'SUCCESS',
                    [styles.failed]: props.type === 'FAILED',
                    [styles.pending]: props.type === 'PENDING',
                    [styles.timer]: props.type === 'TIMER',
                })
            }
        >
            <ClockImage className={styles.clockImage}/>
            {formatText(props.type, props.currentSeconds)}
        </div>
    );
};

export default Badge;
